import React from "react";
import Logo from "../../assets/FullLogo_Transparent_NoBuffer.png";
import "./style.scss";
type Props = {
	children?: React.ReactNode;
};

const NoFound: React.FC<Props> = ({children}) => {
	return (
		<div className="error-wr">
			<img src={Logo} alt="logo" className="error-logo" />
			<h2>404</h2>
		</div>
	);
};

export default NoFound;
